import { GetSteps } from "ui/organisms/ReferenceTrack/ReferenceTrack";
import { referenceTrackDailyLivesMeterId } from "ui/organisms/ReferenceTrack/referenceTrackIds";
import { sharedReferenceTrackConfig } from "ui/templates/Game/sharedReferenceTrackConfig";

export const refrenceTrackIds = {
  playbackState: "playback-state",
  graph: "graph",
  submit: "submit",
};

export const referenceTrackSteps: GetSteps = ({ showAllSharedGameSteps }) => [
  showAllSharedGameSteps && {
    target: `#${refrenceTrackIds.playbackState}`,
    title: "Playback State",
    content: sharedReferenceTrackConfig.playbackState,
    placement: "auto",
  },
  {
    target: `#${refrenceTrackIds.graph}`,
    title: "Match the Pan",
    content: (
      <div>
        <p className={"mb-2"}>
          Slide the pan knob left and right until your mix is panned to the same
          position as the reference.
        </p>
      </div>
    ),

    placement: "auto",
  },
  showAllSharedGameSteps && {
    target: `#${refrenceTrackIds.submit}`,
    title: "Submit your answer",
    content: sharedReferenceTrackConfig.submit,

    placement: "auto",
  },
  showAllSharedGameSteps && {
    target: `#${referenceTrackDailyLivesMeterId}`,
    title: "Daily Lives Meter",
    content: sharedReferenceTrackConfig.dailyLivesMeter,
  },
];
